import PlatformTypeEnum from "@/enums/PlatformTypeEnum";

export function storeImage(platformTypeId) {
  if (
    !PlatformTypeEnum.isValidId(platformTypeId) ||
    platformTypeId === PlatformTypeEnum.ALL
  ) {
    return [
      require("@/assets/img/stores/playStore.png"),
      require("@/assets/img/stores/appStore.png"),
    ];
  }

  const platformTypeName = PlatformTypeEnum.fromId(platformTypeId);
  let imageName = "";

  switch (platformTypeName) {
    case "Play Store":
      imageName = "playStore.png";
      break;
    case "App Store":
      imageName = "appStore.png";
      break;
    default:
      imageName = "appStore.png";
      break;
  }

  return [require(`@/assets/img/stores/${imageName}`)];
}

export const detectPlatform = function (url) {
  if (/itunes\.apple\.com|apps\.apple\.com/.test(url)) {
    return PlatformTypeEnum.APP_STORE;
  } else if (/play\.google\.com/.test(url)) {
    return PlatformTypeEnum.PLAY_STORE;
  }
  return null;
};

export const extractStoreId = function (url, platform) {
  if (platform === PlatformTypeEnum.APP_STORE) {
    const match = url.match(/id(\d+)/);
    return match ? `id${match[1]}` : null;
  } else if (platform === PlatformTypeEnum.PLAY_STORE) {
    const match = url.match(/[?&]id=([^&]+)/);
    return match ? match[1] : null;
  }
  return null;
};

export const extractDeveloperId = function (url, platform) {
  if (platform === PlatformTypeEnum.APP_STORE) {
    const match = url.match(/id(\d+)/);
    return match ? `id${match[1]}` : null;
  }

  if (platform === PlatformTypeEnum.PLAY_STORE) {
    const idMatch = url.match(/[?&]id=([^&]+)/);
    const devMatch = url.match(/\/dev\?id=([^&]+)/);

    return idMatch
      ? decodeURIComponent(idMatch[1])
      : devMatch
      ? decodeURIComponent(devMatch[1])
      : null;
  }

  return null;
};

export const extractPlayStoreCountry = function (url) {
  const match = url.match(/[?&]gl=([^&]+)/);
  return match ? match[1].toUpperCase() : null;
};
